import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  coachCoacheeWidget: {
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  rightSection: {
    width: "45%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  leftSection: {
    width: "calc(100% - 60%)",
    overflowWrap: "break-word",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  supportSection: {
    "&.MuiTypography-subtitle2": {
      fontSize: 15,
      color: "#283941",
    },
    "&.MuiPaper-root": {
      color: "#283941",
    },
  },
  footer: {
    float: "right"
  },
  footerLogo: {
    height: 19,
    width: 50,
    marginLeft: 10,
  },
  // bgImg:{
  //   height:'auto',
  //   [theme.breakpoints.down("sm")]: {
  //     height:400,
  //   },
  //  },
  placeholderContent: {
    width: '100%',
    background: 'transparent linear-gradient(1deg, #F0F2F6 0%, #FFFEFE 100%) 0% 0% no-repeat padding-box',
    borderRadius: 10,
    height: '70vh',
    "& button": {
      padding: '10px 24px'
    }
  },
  paraContent: {
    color: '#707E8C',
    margin: '5px 0 20px'
  },
  placeholderImg: {
    width: 100,
    marginBottom: 10,
  },
  previewIndicator: {
    position: "fixed",
    left: 0,
    bottom: 0,
    color: "#fff",
    "& svg": {
      width: 50,
      height: 28
    }
  }
}));

export default useStyles;
